import React from "react";
import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import loadable from "@loadable/component";
import { SocialCurationsProps } from "./SocialCurations/SocialCurations";
import { ContentfulSocialCurationsData } from "../../types/ContentfulTypes";
import { productPageLayouts } from "../pluginOwners";

export const SocialCurationsComponent: ComponentToBeRegistered<SocialCurationsProps> = {
  placeholder: Placeholder.AfterTab,
  Component: loadable<SocialCurationsProps>(() => import("./SocialCurations/SocialCurations")),
  name: "SocialCurations",
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    return showOlapic(context.pageProps.socialCurations);
  },
};

export const socialCurations: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, SocialCurationsComponent);
  },
  pluginOwner: productPageLayouts,
};

const showOlapic = (data?: ContentfulSocialCurationsData) => {
  return !!data?.apiKey && !!data.widget.instanceId && !!data.source.id;
};
